module.exports = __webpack_public_path__ + "static/gear-954f8af26cd6bcdbfb54353b0e3de188.png";